import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { ProfileInfo } from '../../../models/profile-info';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppSettings } from '../../../utils/app-settings';
import { Parent } from '../../../models/parent';
import { map } from 'rxjs/operators';

@Injectable()
export class UserService {

  constructor(private http: HttpClient) { }

  private _profileInfo: ReplaySubject<ProfileInfo> = new ReplaySubject<ProfileInfo>(1);
  private http_fetched = false;

  getLoggedInUser(access_token?: string): Observable<ProfileInfo> {
    if (!this.http_fetched) {
      this.http_fetched = true;
      this.http.get<ProfileInfo>(`${AppSettings.apiUrl}users/getloggedinuser`,access_token ? { headers: new HttpHeaders({ "Authorization": 'Bearer ' + access_token }) } : {})
        .subscribe((res) => {
          this._profileInfo.next(res);
        },
          (error) => {
            console.error(error);
            this.http_fetched = false;
          }
        );
    }
    return this._profileInfo.asObservable();
  }

  editUserProfile(editedProfile: Parent) {
    return this.http.put(`${AppSettings.apiUrl}users`, editedProfile)
      .pipe(map(res => { return res }));
  }
}
